import React, { createContext, useContext } from "react";

import PropTypes from "prop-types";

import { useBootstrap } from "components/store/source";

const initialReferralState = {};

export const ReferralContext = createContext(initialReferralState);

// Context to extract Referral data from server props and bootstrap flags
function ReferralContextProvider({ referralData, children }) {
  const {
    featureFlags: { referralEnabled, referralCreditAmount },
  } = useBootstrap();
  const data = { ...referralData, referralEnabled, referralCreditAmount };

  return (
    <ReferralContext.Provider value={data}>{children}</ReferralContext.Provider>
  );
}

ReferralContextProvider.propTypes = {
  referralData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    referralCode: PropTypes.string.isRequired,
  }),
  children: PropTypes.node.isRequired,
};

export const withReferralContext =
  WrappedComponent =>
  // eslint-disable-next-line react/display-name
  ({ referralData, others }) => {
    return (
      <ReferralContextProvider referralData={referralData}>
        <WrappedComponent {...others} />
      </ReferralContextProvider>
    );
  };

export const useReferral = () => useContext(ReferralContext);
